import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Table } from '../table';
import { getFileManagerTableConfig } from './file-manager-table-config';
import { FileUploader } from '../file-uploader';
import styles from './file-manager.module.css';
import clsx from 'clsx';
export const FileManager = (props) => {
    const { t } = useTranslation();
    const { readonly, files, reverseDirection, error, maxFileCount, showLoader } = props;
    const showFiles = (files === null || files === void 0 ? void 0 : files.length) > 0;
    const isMaxFilesCountReached = maxFileCount && files.length >= maxFileCount;
    const tableColumns = getFileManagerTableConfig(files, props, { t });
    const onRowClick = (_, { rowIndex }) => {
        const url = files[rowIndex].url;
        window.open(url, '_blank');
    };
    return (_jsxs("div", { className: clsx({
            [styles.reverse]: reverseDirection,
        }), children: [!readonly && !isMaxFilesCountReached && (_jsx(FileUploader, { getUploadParams: props.getUploadParams, onFileUploaded: props.onFileUploaded, buttonContent: props.buttonContent, buttonFullWidth: props.buttonFullWidth, fileDescription: props.fileDescription, fileAccept: props.fileAccept, error: error, showLoader: showLoader })), showFiles && (_jsx(Table, { options: {
                    responsive: 'standard',
                    pagination: false,
                    sort: false,
                    count: files.length,
                    onRowClick,
                }, title: " ", columns: tableColumns, data: files }))] }));
};
